import i18n from "i18next";
import Fetch from "i18next-fetch-backend";
import { initReactI18next } from "react-i18next";

const elaraDetector = {
  type: "languageDetector",
  detect() {
    const lang = localStorage.getItem("elara-lang");
    return lang || "en";
  },
};

void i18n
  .use(elaraDetector)
  .use(Fetch)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // lng: "en",
    supportedLngs: ["en", "sv"],
    fallbackLng: false,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    backend: {
      loadPath: "/translations/{{lng}}/{{ns}}.json",
    },
  });

export default i18n;
